import { c as _c } from "react/compiler-runtime";
import { MaterialIcon, MaterialNameType } from "@website/icons/material";
import { AlertPropertiesType } from "@website/ui/alert/alert.types";
import { alertConfig, iconStyleConfig, iconTypeConfig } from "@website/ui/alert/config";
import { FC } from "react";
export const Alert: FC<AlertPropertiesType> = properties => {
  const $ = _c(24);
  const {
    className,
    title,
    severity: t0,
    type: t1,
    size: t2,
    Action,
    isCloseable: t3,
    startIcon,
    showIcon: t4,
    onClose,
    onClick,
    onKeyDown,
    noClamp
  } = properties;
  const severity = t0 === undefined ? "default" : t0;
  const type = t1 === undefined ? "contained" : t1;
  const size = t2 === undefined ? "one-line" : t2;
  const isCloseable = t3 === undefined ? true : t3;
  const showIcon = t4 === undefined ? true : t4;
  const t5 = `flex max-h-[92px] w-full gap-1 rounded-lg pl-2 pr-4 ${alertConfig[type].style} ${alertConfig[type].severity[severity]} ${className ?? ""} ${size}`;
  const t6 = `flex flex-1 items-center justify-start ${showIcon ? "gap-2" : ""} py-4`;
  let t7;
  if ($[0] !== severity || $[1] !== showIcon || $[2] !== startIcon || $[3] !== type) {
    t7 = showIcon && <div className={`flex items-center justify-center text-2xl leading-6 ${type === "contained" ? iconStyleConfig.white : iconStyleConfig[severity]}`}>{startIcon || <MaterialIcon name={iconTypeConfig[severity] as MaterialNameType} variant="outlined" />}</div>;
    $[0] = severity;
    $[1] = showIcon;
    $[2] = startIcon;
    $[3] = type;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const t8 = `text-body-2 ${noClamp ? "" : "line-clamp-3"}`;
  let t9;
  if ($[5] !== t8 || $[6] !== title) {
    t9 = <div className={t8}>{title}</div>;
    $[5] = t8;
    $[6] = title;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t6 || $[9] !== t7 || $[10] !== t9) {
    t10 = <div className={t6}>{t7}{t9}</div>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== isCloseable || $[13] !== onClose) {
    t11 = isCloseable && <button onClick={onClose} tabIndex={0}><MaterialIcon className="text-2xl leading-6" name="close" /></button>;
    $[12] = isCloseable;
    $[13] = onClose;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== Action || $[16] !== t11) {
    t12 = <div className="flex items-center justify-end gap-2 p-2">{Action}{t11}</div>;
    $[15] = Action;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== onClick || $[19] !== onKeyDown || $[20] !== t10 || $[21] !== t12 || $[22] !== t5) {
    t13 = <div className={t5} onClick={onClick} onKeyDown={onKeyDown} role="alert">{t10}{t12}</div>;
    $[18] = onClick;
    $[19] = onKeyDown;
    $[20] = t10;
    $[21] = t12;
    $[22] = t5;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
};